import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const guidelines = [{
  title: 'Initial Contact',
  points: ['Use respectful language in all communications', 'Introduce yourself with your real name and experience level', 'Be clear about your interests and boundaries', 'Understand that I may not respond to generic or disrespectful messages']
}, {
  title: 'Before Your Session',
  points: ['Complete the screening process fully and honestly', 'Arrive on time and well-groomed', 'Bring the agreed-upon tribute in a sealed envelope', 'Review and respect all pre-session agreements']
}, {
  title: 'During Your Session',
  points: ['Communicate openly about your physical and emotional state', 'Use your safeword if needed without hesitation', 'Follow instructions and protocols as discussed', 'Trust the process and remain present']
}, {
  title: 'After Your Session',
  points: ['Provide feedback about your experience', 'Respect confidentiality and discretion', 'Allow time for integration and aftercare', 'Book future sessions with advance notice']
}];
export function Etiquette() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="etiquette" ref={ref} className="py-24 lg:py-32 bg-ink" data-id="element-167">
      <div className="max-w-6xl mx-auto px-6 lg:px-12" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-169">
          <p className="text-gold text-xs uppercase tracking-[0.3em] mb-4 font-cinzel" data-id="element-170">
            BDSM Education & Etiquette
          </p>
          <h2 className="font-cormorant text-bone text-4xl lg:text-6xl font-light mb-6" data-id="element-171">
            Protocol & Expectations
          </h2>
          <p className="text-silver-muted text-lg max-w-2xl mx-auto" data-id="element-172">
            Clear communication and mutual respect form the foundation of every
            interaction.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-173">
          {guidelines.map((section, index) => <motion.div key={section.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="bg-onyx border border-gold/10 p-8" data-id="element-174">
              <h3 className="font-cormorant text-bone text-2xl mb-6 pb-4 border-b border-gold/20" data-id="element-175">
                {section.title}
              </h3>
              <ul className="space-y-3" data-id="element-176">
                {section.points.map((point, i) => <li key={i} className="flex items-start gap-3" data-id="element-177">
                    <CheckIcon size={16} className="text-gold mt-1 flex-shrink-0" data-id="element-178" />
                    <span className="text-silver-muted text-sm leading-relaxed" data-id="element-179">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 p-8 bg-aubergine border border-gold/20" data-id="element-180">
          <h3 className="font-cormorant text-bone text-2xl mb-4" data-id="element-181">
            Session Expectations
          </h3>
          <p className="text-silver-muted leading-relaxed mb-4" data-id="element-182">
            Every session begins with a thorough negotiation of boundaries,
            desires, and limits. We will discuss safewords, physical
            considerations, and emotional needs before any play begins.
          </p>
          <p className="text-silver-muted leading-relaxed" data-id="element-183">
            Sessions are conducted in a private, professional space designed for
            safety and discretion. All equipment is sanitized, and consent is
            continuously monitored throughout our time together.
          </p>
        </motion.div>
      </div>
    </section>;
}